<script setup lang="ts">
import ArrowLeftIcon from '@/assets/icons/ArrowLeftIcon.vue';
</script>

<template>
  <button class="h-button flex items-center gap-sm px-md rounded-md state-effects bg-white" type="button">
    <ArrowLeftIcon class="size-icon" />
    <slot />
  </button>
</template>
